export enum ButtonAppearance {
  ALFA = 'ALFA',
  BRAVO = 'BRAVO',
}
